export default __webpack_public_path__ + "static/pexels-lisa-1453499_-72bb28192ef179770587cd6f3d157b83.jpg";